import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="artist-preview-dialog"
// Opens a <dialog> with the artist submission loaded in a turbo-frame.
// Usage on the trigger element:
//   data-action="click->artist-preview-dialog#open"
//   data-artist-preview-dialog-url-param="<path>"
export default class extends Controller {
  static targets = ["dialog", "frame"]

  open(event) {
    event.preventDefault()
    event.stopPropagation()
    const url = event.params.url
    if (!url) return
    this.frameTarget.src = url
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
    // Reset the frame so it doesn't hold stale content
    this.frameTarget.src = ""
    this.frameTarget.innerHTML = ""
  }

  // Close when user clicks outside the dialog box (the ::backdrop area)
  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }
}
